import React, { useState } from 'react';
import Button from '../../ui/Button.jsx';
import Input from '../../ui/Input.jsx';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../ui/Card.jsx';

export default function AdminSecretGate({
  initialSecret = '',
  isSubmitting = false,
  error = '',
  onSubmit
}) {
  const [secret, setSecret] = useState(initialSecret);

  const handleSubmit = async (event) => {
    event.preventDefault();
    await onSubmit?.(secret);
  };

  return (
    <Card className="max-w-xl mx-auto">
      <CardHeader className="space-y-3">
        <div className="ptcm-section-pill w-fit">
          Backoffice
        </div>
        <div className="space-y-2">
          <CardTitle className="text-2xl">Accès protégé</CardTitle>
          <CardDescription className="text-base">
            Saisissez le secret configuré côté serveur dans `ADMIN_BACKOFFICE_SECRET` pour consulter le tableau de suivi.
          </CardDescription>
        </div>
      </CardHeader>
      <CardContent>
        <form className="space-y-4" onSubmit={handleSubmit}>
          <div className="space-y-2">
            <label className="text-sm font-semibold text-ptcm-ink dark:text-gray-100">
              Secret admin
            </label>
            <Input
              type="password"
              value={secret}
              onChange={(event) => setSecret(event.target.value)}
              placeholder="Entrez le secret"
              autoComplete="current-password"
            />
          </div>

          {error ? (
            <div className="rounded-[24px] border border-red-200/70 bg-red-50/90 px-4 py-3 text-sm text-red-700 dark:border-red-900/30 dark:bg-red-900/20 dark:text-red-300">
              {error}
            </div>
          ) : null}

          <Button type="submit" size="lg" className="w-full" disabled={isSubmitting || !secret.trim()}>
            {isSubmitting ? 'Vérification…' : 'Ouvrir le backoffice'}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
}
